import { MINUTES_IN_HOUR } from '@app/utils/transformMinutesToHours/transformMinutesToHours.consts';
import type { NTransformMinutesToHours } from '@app/utils/transformMinutesToHours/transformMinutesToHours.types';

/**
 * Преобразует минуты в часы с минутами.
 * Примеры использования:
 * 1) 1 минута -> 0 часов 01 минута
 * 2) 59 минут -> 0 часов 59 минут
 * 3) 61 минута -> 1 час 01 минута
 * 4) 119 минут -> 1 час 59 минут
 * @param minutes – количество минут, полученных с сервера
 * @returns количество часов и минут
 */

export const transformMinutesToHours: NTransformMinutesToHours.Main = (
  minutes
) => {
  const hours = Math.floor(minutes / MINUTES_IN_HOUR);
  const minutesRest = minutes % MINUTES_IN_HOUR;

  const formatTime = (time: number) => (time < 10 ? `0${time}` : String(time));

  return {
    hours: formatTime(hours),
    minutes: formatTime(minutesRest),
  };
};
